/**
 * UI Component Library — barrel export
 *
 * Import from "@/components/ui" for convenience:
 *   import { Button, Input, Card } from "@/components/ui";
 */

// Tier 1 — Primitives
export { Button, buttonVariants } from "./button";
export type { ButtonProps } from "./button";

export { Input } from "./input";
export type { InputProps } from "./input";

export { Textarea } from "./textarea";
export type { TextareaProps } from "./textarea";

export { Select } from "./select";
export type { SelectProps } from "./select";

export { CountryPicker } from "./country-picker";

export { Checkbox, CheckboxGroup } from "./checkbox";
export type { CheckboxProps, CheckboxGroupProps } from "./checkbox";

export { Radio, RadioGroup } from "./radio";
export type { RadioProps, RadioGroupProps } from "./radio";

export { Toggle } from "./toggle";
export type { ToggleProps } from "./toggle";

export { Badge, badgeVariants } from "./badge";
export type { BadgeProps } from "./badge";

export { Icon } from "./icon";
export type { IconProps } from "./icon";

// Tier 2 — Composite
export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
} from "./card";
export type { CardProps } from "./card";

export {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableSortHeader,
  TableEmpty,
  TableSkeleton,
  TablePagination,
} from "./table";

export {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalBody,
  ModalFooter,
} from "./modal";
export type { ModalProps } from "./modal";

export { Drawer, DrawerHeader, DrawerBody, DrawerFooter } from "./drawer";
export type { DrawerProps } from "./drawer";

export {
  DropdownMenu,
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
  DropdownSeparator,
  DropdownLabel,
} from "./dropdown-menu";

export { Tabs, TabList, TabTrigger, TabPanel } from "./tabs";
export type { TabsProps, TabListProps, TabTriggerProps, TabPanelProps } from "./tabs";

export { ToastProvider, useToast } from "./toast";

export { ConfirmProvider, useConfirm, usePrompt } from "./confirm";

// Tier 3 — Layout
export { PageShell } from "./page-shell";
export type { PageShellProps } from "./page-shell";

export { PageHeader } from "./page-header";
export type { PageHeaderProps } from "./page-header";

export { BackLink } from "./back-link";
export type { BackLinkProps } from "./back-link";

export { Section } from "./section";
export type { SectionProps } from "./section";

export { CollapsibleSection } from "./collapsible-section";
export type { CollapsibleSectionProps } from "./collapsible-section";

export { EmptyState } from "./empty-state";
export type { EmptyStateProps } from "./empty-state";

export { Skeleton, SkeletonCard, SkeletonRow, SkeletonAvatar } from "./skeleton";
export type { SkeletonProps } from "./skeleton";
